export const keys = {
  customer: (id) => ["customer", id],
  customers: "customers",
  invoices: (id) => ["invoices", id],
  errors: "errors",
  clinicInvoices: "clinicInvoices",
  batchCharges: "batchCharges",
};
